import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  path {
    fill: ${({ theme }) => theme.colors.accentGray04};
  }

  &.blue path {
    fill: ${({ theme }) => theme.colors.text05};
  }
`;

export const FilterIcon = (props) => (
  <SVG {...props} width="15" height="15" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.697 7.088a.921.921 0 0 1 .246.627v6.82c0 .411.5.62.796.33l1.92-2.18c.257-.305.399-.456.399-.759v-4.21c0-.231.088-.455.246-.626l5.51-5.925C15.226.721 14.909 0 14.298 0H.702c-.61 0-.93.72-.515 1.165l5.51 5.923z" />
  </SVG>
);

export const NoFilterIcon = (props) => (
  <SVG {...props} width="16" height="18" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2 5.743 9 4.482 7.664a15359.486 15359.486 0 0 0-4.247-4.48.776.776 0 0 1-.225-.4.672.672 0 0 1 .601-.774C.684 2.004.757 2 .831 2H12zM14.504 1.5l.996.872-.487.573-2.492 2.927-2.469 2.897c-.315.37-.628.74-.944 1.107a.233.233 0 0 0-.06.164c.001 1.231-.003 2.462.004 3.692a.982.982 0 0 1-.244.68c-.327.379-.652.759-.98 1.137-.333.385-.668.768-1.002 1.153-.15.173-.337.229-.528.156-.191-.073-.299-.24-.299-.47V13.53L2.617 17.5 1.5 16.523 14.504 1.5" />
  </SVG>
);
